import { useEffect, useState } from "react";

import { isEmpty } from "@s-libs/micro-dash";
import { useRouter } from "next/router";

/**
 * Method that add a submenu item into the collection.
 * The arguments are generated by the Angelou Anchor component, and are based on the menu Item definition.
 * @example
 * // returns [
 *  {
 *    id: 'directory',
 *    options: [{
 *      id: 'schools',
 *      title: 'Schools',
 *      relatedOptions: [{
 *        id: 'subItem',
 *        ariaLabel: 'subItem',
 *        title: 'subItem',
 *        url: '/url-test'
 *      }]
 *    }]
 * }]
 * addSubMenuItem(
 * [
 *  {
 *    id: 'directory',
 *    options: [{
 *      id: 'schools',
 *      title: 'Schools',
 *    }]
 * }],
 * 'directory',
 * 'test',
 *  {id: 'subItem', ariaLabel: 'subItem', title: 'subItem', url: '/url'}
 * );
 * @returns {Array} Returns a new copy of the menu options array with the new item.
 */
const addSubMenuItem = (
  menuOptions = [],
  menuSection,
  parentSection,
  subMenuItem = {},
) => {
  return menuOptions.map((section) => {
    if (section.id === menuSection) {
      const { options } = section;
      return {
        ...section,
        options: options.map((option) => {
          return parentSection === option.id
            ? {
                ...option,
                relatedOptions: [subMenuItem],
              }
            : option;
        }),
      };
    }

    return section;
  });
};

/**
 * Hook that returns the sidebar menu options.
 * @param {Array} menuOptions - The menu options.
 * @param {Object|Array} subMenuRecordInfo - subMenuInfo to add to the sidebar.
 *
 * @returns {Object} Returns an object with the sidebar data.
 */
const useSidebarMenuOptions = (menuOptions, subMenuRecordInfo) => {
  const { asPath } = useRouter();

  const [sideBarData, setSideBarData] = useState({
    menuItems: menuOptions,
    selectedId: "",
  });

  useEffect(() => {
    const section = asPath
      .split("/")
      .filter((pathSection) => !isEmpty(pathSection))[1];

    if (subMenuRecordInfo) {
      setSideBarData({
        selectedId: subMenuRecordInfo.id,
        menuItems: addSubMenuItem(menuOptions, "account", section, {
          ...subMenuRecordInfo,
          url: asPath,
        }),
      });
    } else {
      setSideBarData({ menuItems: menuOptions, selectedId: section });
    }
  }, [subMenuRecordInfo]);
  return sideBarData;
};

export default useSidebarMenuOptions;
